import { Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { FullScreenLoading, GlobalLayout } from './components/common';
import { PAGE_ROUTE } from './constants/url';
import { LayoutChat, LayoutMain, LayoutSub } from './layouts';
import {
  ChatList,
  Main,
  CreateNewCharacter,
  SignUp,
  CreateGroupChat,
  ChangePassword,
  ResetPassword,
  MyPage,
  GroupChat,
  MoreOneOnOne,
  SearchRoom,
  Settings,
  Report,
  Account,
  Terms,
  Privacy,
  Chat01,
  AssetStore,
  Subscription,
  SignUpSuccess,
  PasswordSuccess,
  CharacterResult,
  SubscriptionWaiting,
  CharacterDetails,
  Explore,
  NotFound,
  EditCharacter,
  SignInHome,
  SignIn,
  Mystery,
  ChatConcept,
  MissionGame,
  GameEnteringRoutePage,
  MissionChatPage,
  MissionResultPage,
} from './pages';
import AuthRedirect from './router/AuthRedirect';
import PrivateRoute from './router/PrivateRoute';

const routes: RouteObject[] = [
  {
    element: <GlobalLayout />,
    errorElement: (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    ),
    children: [
      {
        element: <AuthRedirect />,
        children: [
          { path: PAGE_ROUTE.SIGNIN_HOME, element: <SignInHome /> },
          { path: PAGE_ROUTE.SIGNIN, element: <SignIn /> },
          { path: PAGE_ROUTE.SIGNUP, element: <SignUp /> },
          { path: PAGE_ROUTE.RESET_PASSWORD, element: <ResetPassword /> },
          { path: PAGE_ROUTE.PASSWORD_SUCCESS, element: <PasswordSuccess /> },
          { path: PAGE_ROUTE.SIGNUP_SUCCESS, element: <SignUpSuccess /> },
        ],
      },

      {
        element: <PrivateRoute />,
        children: [
          {
            element: <LayoutMain />,
            children: [
              { index: true, path: PAGE_ROUTE.MAIN, element: <Main /> },
              { path: PAGE_ROUTE.CHAT_LIST, element: <ChatList /> },
              { path: PAGE_ROUTE.MYPAGE, element: <MyPage /> },
              { path: PAGE_ROUTE.ASSET, element: <AssetStore /> },
              { path: PAGE_ROUTE.EXPLORE, element: <Explore /> },
            ],
          },
          {
            element: <LayoutSub />,
            children: [
              { path: PAGE_ROUTE.SETTINGS, element: <Settings /> },
              { path: PAGE_ROUTE.ACCOUNT, element: <Account /> },
              { path: PAGE_ROUTE.CHANGE_PASSWORD, element: <ChangePassword /> },
              { path: PAGE_ROUTE.MORE_ONE_ON_ONE, element: <MoreOneOnOne /> },
              { path: PAGE_ROUTE.SUBSCRIPTION, element: <Subscription /> },
              {
                path: PAGE_ROUTE.SUBSCRIPTION_WAITING,
                element: <SubscriptionWaiting />,
              },
              {
                path: PAGE_ROUTE.TERMS_OF_SERVICE,
                element: <Terms />,
              },
              { path: PAGE_ROUTE.PRIVACY_POLICY, element: <Privacy /> },
            ],
          },
          {
            element: <LayoutChat />,
            children: [
              {
                path: PAGE_ROUTE.CHAT,
                element: <Navigate to={PAGE_ROUTE.CHAT_LIST} replace />,
              },
              { path: `${PAGE_ROUTE.CHAT}/:id`, element: <Chat01 /> },
              { path: `chat2/:id`, element: <Chat01 /> },
              {
                path: PAGE_ROUTE.GROUP_CHAT,
                element: <Navigate to={PAGE_ROUTE.CHAT_LIST} replace />,
              },
              { path: `${PAGE_ROUTE.GROUP_CHAT}/:id`, element: <GroupChat /> },
            ],
          },
          {
            path: PAGE_ROUTE.CREATE_NEW_CHARACTER,
            element: <CreateNewCharacter />,
          },
          {
            path: `${PAGE_ROUTE.MYSTERY}/:id`,
            element: <Mystery />,
          },
          {
            path: `${PAGE_ROUTE.CHAT_CONCEPT}/:id`,
            element: <ChatConcept />,
          },
          {
            path: `${PAGE_ROUTE.MISSION_RESULT}`,
            element: <MissionResultPage />,
          },
          {
            path: `${PAGE_ROUTE.MISSION_CHAT}`,
            element: <MissionChatPage />,
          },
          {
            path: `${PAGE_ROUTE.MISSION_GAME}/:id`,
            element: <MissionGame />,
          },
          {
            path: `${PAGE_ROUTE.MISSION_GAME}/:page/:id`,
            element: <GameEnteringRoutePage />,
          },

          {
            path: PAGE_ROUTE.EDIT_CHARACTER,
            element: (
              <Suspense fallback={<FullScreenLoading />}>
                <EditCharacter />
              </Suspense>
            ),
          },
          { path: PAGE_ROUTE.CREATE_GROUP_CHAT, element: <CreateGroupChat /> },
          {
            path: PAGE_ROUTE.CHARACTER_DETAILS,
            element: <Navigate to={PAGE_ROUTE.MAIN} replace />,
          },
          {
            path: `${PAGE_ROUTE.CHARACTER_DETAILS}/:id`,
            element: <CharacterDetails />,
          },
          { path: PAGE_ROUTE.SEARCH_ROOM, element: <SearchRoom /> },
          { path: PAGE_ROUTE.REPORT, element: <Report /> },
          { path: PAGE_ROUTE.SEARCH_CHARACTER, element: <CharacterResult /> },
        ],
      },
      { path: PAGE_ROUTE.TERMS, element: <Terms /> },
      { path: PAGE_ROUTE.PRIVACY, element: <Privacy /> },
    ],
  },
];

export default routes;
